package com.fantasytenis.shared.data.engagement.api

import com.fantasytenis.shared.data.engagement.dto.AchievementsResponseDto
import com.fantasytenis.shared.data.engagement.dto.EngagementResponseDto
import io.ktor.client.*
import io.ktor.client.call.*
import io.ktor.client.request.*

/**
 * API client for engagement endpoints.
 */
class EngagementApi(
    private val httpClient: HttpClient,
    private val baseUrl: String
) {
    /**
     * Get current user's engagement data.
     * GET /v2/engagement/me
     */
    suspend fun getMyEngagement(): EngagementResponseDto {
        return httpClient.get("${baseUrl}engagement/me").body()
    }

    /**
     * Get all achievement definitions.
     * GET /v2/engagement/achievements
     */
    suspend fun getAchievements(): AchievementsResponseDto {
        return httpClient.get("${baseUrl}engagement/achievements").body()
    }

    /**
     * Use weekly streak saver.
     * POST /v2/engagement/streak-saver
     */
    suspend fun useStreakSaver(): EngagementResponseDto {
        return httpClient.post("${baseUrl}engagement/streak-saver").body()
    }
}
